import { useContext } from "react";
import s from './index.module.css';
import { Comments } from "./components/Comments";
import { UnavailableStudents } from "./components/UnavailableStudents";
import { SeminariansСlasses } from "./components/SeminariansСlasses";
import { CommentToDzAndLessonTotic } from "./components/CommentToDzAndLessonTotic";
import { ModalSettingContext } from "../..";
import { CollapsePanel } from "../CollapsePanel";
import { conferenceTypesEnum } from "../ConferenceType/conferenceTypesEnum";
import { InRecording } from "./components/InRecording";

export const AdditionalSettings = () => {
    
    const { state } = useContext(ModalSettingContext);

    return (
        <CollapsePanel
            className={s.collapse} 
            header='Дополнительные настройки'
        >
            {
                !state?.isOffline && (
                    <InRecording />
                )
            }
            <Comments />
            
            {
                state.conference_type === conferenceTypesEnum.group && <UnavailableStudents />
            }
            <SeminariansСlasses />
            <CommentToDzAndLessonTotic />
        </CollapsePanel>
    )
}
